module.exports = "/_next/static/images/9639fa16c70e41a0b615c266556948c9-man-looking-up-smiling-xs@1x.jpg.webp";